export const PT = {
  fieldset: {
    root: "dark:border-surface-500! dark:bg-surface-800!",
    legend: "px-2! bg-transparent dark:bg-transparent! border-0!",
  },
  dialog: {
    header: "p-3! border border-b-0 rounded-t-md border-t-2 border-surface-200 dark:border-surface-900 bg-surface-200 dark:bg-surface-900",
  },
  selectbutton: {
    button: "px-2! py-2!",
  },
  card: {
    root: "bg-white/80! backdrop-blur-xl dark:bg-white/5! border-surface-200! dark:border-surface-600! border! rounded-xl!",
  },
  knob: {
    range: "dark:stroke-surface-600!",
  },
  metergroup: {
    metercontainer: "dark:bg-gray-600!",
    meter: "bg-primary-500",
  },
  scrollpanel: {
    bary: "bg-surface-200! dark:bg-surface-600!",
  },
  panelmenu: {
    headercontent: "group align-middle",
    headeraction: "p-0! pl-5! h-full",
    headerlink: "group-hover:scale-110 dark:group-hover:text-surface-100 transition duration-100 ease-out origin-left",
  },
  listbox: {
    root: "bg-surface-50 dark:bg-surface-900/40",
  },
  calendar: {
    dropdownbutton: {
      root: "rounded-l-none!",
    },
    todaybutton: {
      root: "bg-primary-500!",
    },
    clearbutton: {
      root: "bg-primary-500!",
    },
  },
  badge: {
    root: ({ props }: any) => ({
      class: [
        {
          "bg-primary-500! dark:bg-primary-400!": props.severity == null || props.severity == "primary",
          "bg-secondary-500! dark:bg-secondary-400!": props.severity == "secondary",
          "bg-surface-500! dark:bg-surface-400!": props.severity == "surface",
          "bg-success-500! dark:bg-success-400!": props.severity == "success",
          "bg-info-500! dark:bg-info-400!": props.severity == "info",
          "bg-warning-500! dark:bg-warning-400!": props.severity == "warning",
          "bg-help-500! dark:bg-help-400!": props.severity == "help",
          "bg-danger-500! dark:bg-danger-400!": props.severity == "danger",
        },
      ],
    }),
  },
  button: {
    root: ({ props, context, parent }: any) => ({
      class: [
        // Secondary Button
        {
          "bg-secondary-500! dark:bg-secondary-400!": props.severity === "secondary" && !props.text && !props.outlined && !props.plain,
          "border-secondary-500! dark:border-secondary-400!": props.severity === "secondary" && !props.text && !props.outlined && !props.plain,
        },
        // Secondary Text Button
        { "text-secondary-500! dark:text-secondary-300!": props.text && props.severity === "secondary" && !props.plain },
        // Secondary Outlined Button
        {
          "text-secondary-500! dark:text-secondary-300! border-secondary-500! hover:bg-secondary-300/20!":
            props.outlined && props.severity === "secondary" && !props.plain,
        },

        // Surface Button
        {
          "text-white dark:text-surface-900": props.severity === "surface" && !props.text && !props.outlined && !props.plain,
          "bg-surface-500! dark:bg-surface-500!": props.severity === "surface" && !props.text && !props.outlined && !props.plain,
          "border-surface-500! dark:border-surface-400!": props.severity === "surface" && !props.text && !props.outlined && !props.plain,
        },
        // Surface Text Button
        { "text-surface-500! dark:text-surface-300!": props.text && props.severity === "surface" && !props.plain },
        // Surface Outlined Button
        {
          "border! text-surface-500! dark:text-surface-300! border-surface-500! hover:bg-surface-300/20!":
            props.outlined && props.severity === "surface" && !props.plain,
        },

        // Success Button
        {
          "text-white dark:text-surface-900": props.severity === "success" && !props.text && !props.outlined && !props.plain,
          "bg-success-500! dark:bg-success-400!": props.severity === "success" && !props.text && !props.outlined && !props.plain,
          "border-success-500! border! dark:border-success-400!": props.severity === "success" && !props.text && !props.outlined && !props.plain,
        },
        // Success Text Button
        { "text-success-500! dark:text-success-400!": props.text && props.severity === "success" && !props.plain },
        // Success Outlined Button
        {
          "text-success-500! border-success-500!": props.outlined && props.severity === "success" && !props.plain,
        },
        {
          "hover:bg-success-300/20!": props.outlined && props.severity === "success" && !props.plain && !props.disabled,
        },

        // Info Button
        {
          "bg-info-500! dark:bg-info-400!": props.severity === "info" && !props.text && !props.outlined && !props.plain,
          "border-info-500! dark:border-info-400!": props.severity === "info" && !props.text && !props.outlined && !props.plain,
        },
        // Info Text Button
        { "text-info-500! dark:text-info-400!": props.text && props.severity === "info" && !props.plain },
        // Info Outlined Button
        { "text-info-500! border-info-500! hover:bg-info-300/20! ": props.outlined && props.severity === "info" && !props.plain },

        // Warning Button
        {
          "bg-warning-500! dark:bg-warning-400!": props.severity === "warning" && !props.text && !props.outlined && !props.plain,
          "border-warning-500! dark:border-warning-400!": props.severity === "warning" && !props.text && !props.outlined && !props.plain,
        },
        // Warning Text Button
        { "text-warning-500! dark:text-warning-400!": props.text && props.severity === "warning" && !props.plain },
        // Warning Outlined Button
        { "text-warning-500! border-warning-500! hover:bg-warning-300/20!": props.outlined && props.severity === "warning" && !props.plain },

        // Help Button
        {
          "bg-help-500! dark:bg-help-400!": props.severity === "help" && !props.text && !props.outlined && !props.plain,
          "border-help-500! dark:border-help-400!": props.severity === "help" && !props.text && !props.outlined && !props.plain,
        },
        // Help Text Button
        { "text-help-500! dark:text-help-400!": props.text && props.severity === "help" && !props.plain },
        // Help Outlined Button
        { "text-help-500! border-help-500! hover:bg-help-300/20!": props.outlined && props.severity === "help" && !props.plain },

        // Danger Button
        {
          "bg-danger-500! dark:bg-danger-400!": props.severity === "danger" && !props.text && !props.outlined && !props.plain,
          "border-danger-500! dark:border-danger-400!": props.severity === "danger" && !props.text && !props.outlined && !props.plain,
        },
        // Danger Text Button
        { "text-danger-500! dark:text-danger-400!": props.text && props.severity === "danger" && !props.plain },
        // Danger Outlined Button
        { "text-danger-500! border-danger-500! hover:bg-danger-300/20!": props.outlined && props.severity === "danger" && !props.plain },

        // --- Severity Button States ---
        // Secondary
        {
          "hover:bg-secondary-600! dark:hover:bg-secondary-300! hover:border-secondary-600! dark:hover:border-secondary-300!":
            props.severity === "secondary" && !props.text && !props.outlined && !props.plain,
        },
        { "focus:ring-secondary-400/50! dark:focus:ring-secondary-300/50!": props.severity === "secondary" },
        // Text & Outlined Button
        { "hover:bg-secondary-300/20!": (props.text || props.outlined) && props.severity === "secondary" && !props.plain },

        // Surface
        {
          "hover:bg-surface-600! dark:hover:bg-surface-400! hover:border-surface-600! dark:hover:border-surface-400!":
            props.severity === "surface" && !props.text && !props.outlined && !props.plain,
        },
        { "focus:ring-surface-400/50! dark:focus:ring-surface-300/50!": props.severity === "surface" },
        // Text & Outlined Button
        { "hover:bg-surface-300/20!": (props.text || props.outlined) && props.severity === "surface" && !props.plain },

        // Success
        {
          "hover:bg-success-600! dark:hover:bg-success-300! hover:border-success-600! dark:hover:border-success-300!":
            props.severity === "success" && !props.text && !props.outlined && !props.plain,
        },
        { "focus:ring-success-400/50! dark:focus:ring-success-300/50!": props.severity === "success" },
        // Text & Outlined Button
        { "hover:bg-success-300/20!": (props.text || props.outlined) && props.severity === "success" && !props.plain },

        // Info
        {
          "hover:bg-info-600! dark:hover:bg-info-300! hover:border-info-600! dark:hover:border-info-300!":
            props.severity === "info" && !props.text && !props.outlined && !props.plain,
        },
        { "focus:ring-info-400/50! dark:focus:ring-info-300/50!": props.severity === "info" },
        // Text & Outlined Button
        { "hover:bg-info-300/20!": (props.text || props.outlined) && props.severity === "info" && !props.plain },

        // Warning
        {
          "hover:bg-warning-600! dark:hover:bg-warning-300! hover:border-warning-600! dark:hover:border-warning-300!":
            props.severity === "warning" && !props.text && !props.outlined && !props.plain,
        },
        { "focus:ring-warning-400/50! dark:focus:ring-warning-300/50!": props.severity === "warning" },
        // Text & Outlined Button
        { "hover:bg-warning-300/20!": (props.text || props.outlined) && props.severity === "warning" && !props.plain },

        // Help
        {
          "hover:bg-help-600! dark:hover:bg-help-300! hover:border-help-600! dark:hover:border-help-300!":
            props.severity === "help" && !props.text && !props.outlined && !props.plain,
        },
        { "focus:ring-help-400/50! dark:focus:ring-help-300/50!": props.severity === "help" },
        // Text & Outlined Button
        { "hover:bg-help-300/20!": (props.text || props.outlined) && props.severity === "help" && !props.plain },

        // Danger
        {
          "hover:bg-danger-600! dark:hover:bg-danger-300! hover:border-danger-600! dark:!hover:border-danger-300":
            props.severity === "danger" && !props.text && !props.outlined && !props.plain,
        },
        { "focus:ring-danger-400/50! dark:focus:ring-danger-300/50!": props.severity === "danger" },
        // Text & Outlined Button
        { "hover:bg-danger-300/20!": (props.text || props.outlined) && props.severity === "danger" && !props.plain },
      ],
    }),
  },
  inlinemessage: {
    root: ({ props }: any) => ({
      class: [
        "inline-flex items-center justify-center align-top gap-2",
        "p-3 m-0 rounded-md dark:border",
        {
          "bg-info-100/70! dark:bg-info-500/20!": props.severity == "info",
          "bg-success-100/70! dark:bg-success-500/20!": props.severity == "success",
          "bg-warning-100/70! dark:bg-warning-500/20!": props.severity == "warn",
          "bg-danger-100/70! dark:bg-danger-500/20!": props.severity == "error",
        },
        {
          "dark:border-info-400!": props.severity == "info",
          "dark:border-success-400!": props.severity == "success",
          "dark:border-warning-400!": props.severity == "warn",
          "dark:border-danger-400!": props.severity == "error",
        },
        {
          "text-info-700! dark:text-info-300!": props.severity == "info",
          "text-success-700! dark:text-success-300!": props.severity == "success",
          "text-warning-700! dark:text-warning-300!": props.severity == "warn",
          "text-danger-700! dark:text-danger-300!": props.severity == "error",
        },
      ],
    }),
  },
  message: {
    root: ({ props }: any) => ({
      class: [
        {
          "bg-info-100/70! dark:bg-info-500/20!": props.severity == "info",
          "bg-success-100/70! dark:bg-success-500/20!": props.severity == "success",
          "bg-warning-100/70! dark:bg-warning-500/20!": props.severity == "warn",
          "bg-danger-100/70! dark:bg-danger-500/20!": props.severity == "error",
        },
        {
          "border-info-500! dark:border-info-400!": props.severity == "info",
          "border-success-500! dark:border-success-400!": props.severity == "success",
          "border-warning-500! dark:border-warning-400!": props.severity == "warn",
          "border-danger-500! dark:border-danger-400!": props.severity == "error",
        },
        {
          "text-info-700! dark:text-info-300!": props.severity == "info",
          "text-success-700! dark:text-success-300!": props.severity == "success",
          "text-warning-700! dark:text-warning-300!": props.severity == "warn",
          "text-danger-700! dark:text-danger-300!": props.severity == "error",
        },
      ],
    }),
  },
  tag: {
    root: ({ props }: any) => ({
      class: [
        {
          "bg-primary-500! dark:bg-primary-400!": props.severity == null || props.severity == "primary",
          "bg-secondary-500! dark:bg-secondary-400!": props.severity == "secondary",
          "bg-success-500! dark:bg-success-400!": props.severity == "success",
          "bg-info-500! dark:bg-info-400!": props.severity == "info",
          "bg-warning-500! dark:bg-warning-400!": props.severity == "warning",
          "bg-danger-500! dark:bg-danger-400!": props.severity == "danger",
          "bg-help-500! dark:bg-help-400!": props.severity == "help",
        },
      ],
    }),
  },
  splitbutton: {
    button: {
      root: ({ parent }: any) => ({
        class: [
          "relative",
          // Alignments
          "items-center inline-flex text-center align-bottom justify-center",
          // Sizes & Spacing
          "leading-[normal]",
          {
            "px-4 py-3": parent.props.size === null,
            "text-sm py-2 px-3": parent.props.size === "small",
            "text-xl py-3 px-4": parent.props.size === "large",
          },
          {
            "min-w-12 p-0 py-3": parent.props.label == null && parent.props.icon !== null,
          },
          // Shape
          "rounded-r-none",
          "border-r-0",
          { "rounded-l-full": parent.props.rounded },
          { "rounded-md": !parent.props.rounded, "rounded-full": parent.props.rounded },
          // Link Button
          { "text-primary-600 bg-transparent border-transparent": parent.props.link },
          // Plain Button
          { "text-white bg-gray-500 border border-gray-500": parent.props.plain && !parent.props.outlined && !parent.props.text },
          // Plain Text Button
          { "text-surface-500": parent.props.plain && parent.props.text },
          // Plain Outlined Button
          { "text-surface-500 border border-gray-500": parent.props.plain && parent.props.outlined },
          // Text Button
          { "bg-transparent border-transparent": parent.props.text && !parent.props.plain },
          // Outlined Button
          { "bg-transparent border": parent.props.outlined && !parent.props.plain },
          // Primary Button
          {
            "text-white dark:text-surface-900":
              !parent.props.link && parent.props.severity === null && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-primary-500 dark:bg-primary-400":
              !parent.props.link && parent.props.severity === null && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-primary-500 dark:border-primary-400":
              !parent.props.link && parent.props.severity === null && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Primary Text Button
          { "text-primary-500 dark:text-primary-400": parent.props.text && parent.props.severity === null && !parent.props.plain },
          // Primary Outlined Button
          {
            "text-primary-500 border border-primary-500 hover:bg-primary-300/20":
              parent.props.outlined && parent.props.severity === null && !parent.props.plain,
          },
          // Secondary Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "secondary" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-secondary-500 dark:bg-secondary-400":
              parent.props.severity === "secondary" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-secondary-500 dark:border-secondary-400":
              parent.props.severity === "secondary" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Secondary Text Button
          { "text-secondary-500 dark:text-secondary-400": parent.props.text && parent.props.severity === "secondary" && !parent.props.plain },
          // Secondary Outlined Button
          {
            "text-secondary-500 border-secondary-500 hover:bg-secondary-300/20":
              parent.props.outlined && parent.props.severity === "secondary" && !parent.props.plain,
          },
          // Surface Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "surface" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-surface-500 dark:bg-surface-500":
              parent.props.severity === "surface" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-surface-500 dark:border-surface-500":
              parent.props.severity === "surface" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Surface Text Button
          { "text-surface-500 dark:text-surface-400": parent.props.text && parent.props.severity === "surface" && !parent.props.plain },
          // Surface Outlined Button
          {
            "text-surface-500 border border-surface-500 hover:bg-surface-300/20":
              parent.props.outlined && parent.props.severity === "surface" && !parent.props.plain,
          },
          // Success Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "success" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-success-500 dark:bg-success-400":
              parent.props.severity === "success" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-success-500 dark:border-success-400":
              parent.props.severity === "success" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Success Text Button
          { "text-surface-500 dark:text-surface-400": parent.props.text && parent.props.severity === "success" && !parent.props.plain },
          // Success Outlined Button
          {
            "text-success-500 border-success-500 hover:bg-success-300/20":
              parent.props.outlined && parent.props.severity === "success" && !parent.props.plain,
          },
          // Info Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "info" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-info-500 dark:bg-info-400": parent.props.severity === "info" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-info-500 dark:border-info-400":
              parent.props.severity === "info" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Info Text Button
          { "text-info-500 dark:text-info-400": parent.props.text && parent.props.severity === "info" && !parent.props.plain },
          // Info Outlined Button
          {
            "text-info-500 border-info-500 hover:bg-info-300/20 ": parent.props.outlined && parent.props.severity === "info" && !parent.props.plain,
          },
          // Warning Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "warning" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-warning-500 dark:bg-warning-400":
              parent.props.severity === "warning" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-warning-500 dark:border-warning-400":
              parent.props.severity === "warning" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Warning Text Button
          { "text-warning-500 dark:text-warning-400": parent.props.text && parent.props.severity === "warning" && !parent.props.plain },
          // Warning Outlined Button
          {
            "text-warning-500 border-warning-500 hover:bg-warning-300/20":
              parent.props.outlined && parent.props.severity === "warning" && !parent.props.plain,
          },
          // Help Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "help" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-help-500 dark:bg-help-400": parent.props.severity === "help" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-help-500 dark:border-help-400":
              parent.props.severity === "help" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Help Text Button
          { "text-help-500 dark:text-help-400": parent.props.text && parent.props.severity === "help" && !parent.props.plain },
          // Help Outlined Button
          {
            "text-help-500 border-help-500 hover:bg-help-300/20": parent.props.outlined && parent.props.severity === "help" && !parent.props.plain,
          },
          // Danger Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "danger" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-danger-500 dark:bg-danger-400":
              parent.props.severity === "danger" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-danger-500 dark:border-danger-400":
              parent.props.severity === "danger" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Danger Text Button
          { "text-danger-500 dark:text-danger-400": parent.props.text && parent.props.severity === "danger" && !parent.props.plain },
          // Danger Outlined Button
          {
            "text-danger-500 border-danger-500 hover:bg-danger-300/20":
              parent.props.outlined && parent.props.severity === "danger" && !parent.props.plain,
          },
          // --- Severity Button States ---
          "focus:outline-hidden focus:outline-offset-0 focus:ring-3",
          // Link
          { "focus:ring-primary-400/50 dark:focus:ring-primary-300/50": parent.props.link },

          // Plain
          { "hover:bg-gray-600 hover:border-gray-600": parent.props.plain && !parent.props.outlined && !parent.props.text },
          // Text & Outlined Button
          { "hover:bg-surface-300/20": parent.props.plain && (parent.props.text || parent.props.outlined) },

          // Primary
          {
            "hover:bg-primary-600 dark:hover:bg-primary-300 hover:border-primary-600 dark:hover:border-primary-300":
              !parent.props.link && parent.props.severity === null && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          {
            "focus:ring-primary-400/50 dark:focus:ring-primary-300/50":
              !parent.props.link && parent.props.severity === null && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Text & Outlined Button
          { "hover:bg-primary-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === null && !parent.props.plain },

          // Secondary
          {
            "hover:bg-secondary-600 dark:hover:bg-secondary-300 hover:border-secondary-600 dark:hover:border-secondary-300":
              parent.props.severity === "secondary" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-secondary-400/50 dark:focus:ring-secondary-300/50": parent.props.severity === "secondary" },
          // Text & Outlined Button
          {
            "hover:bg-secondary-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "secondary" && !parent.props.plain,
          },
          // Surface
          {
            "hover:bg-surface-600 dark:hover:bg-surface-400 hover:border-surface-600 dark:hover:border-surface-400":
              parent.props.severity === "surface" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-surface-400/50 dark:focus:ring-surface-300/50": parent.props.severity === "surface" },
          // Text & Outlined Button
          { "hover:bg-surface-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "surface" && !parent.props.plain },
          // Success
          {
            "hover:bg-success-600 dark:hover:bg-success-300 hover:border-success-600 dark:hover:border-success-300":
              parent.props.severity === "success" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-success-400/50 dark:focus:ring-success-300/50": parent.props.severity === "success" },
          // Text & Outlined Button
          {
            "hover:bg-success-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "success" && !parent.props.plain,
          },
          // Info
          {
            "hover:bg-info-600 dark:hover:bg-info-300 hover:border-info-600 dark:hover:border-info-300":
              parent.props.severity === "info" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-info-400/50 dark:focus:ring-info-300/50": parent.props.severity === "info" },
          // Text & Outlined Button
          { "hover:bg-info-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "info" && !parent.props.plain },
          // Warning
          {
            "hover:bg-warning-600 dark:hover:bg-warning-300 hover:border-warning-600 dark:hover:border-warning-300":
              parent.props.severity === "warning" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-warning-400/50 dark:focus:ring-warning-300/50!": parent.props.severity === "warning" },
          // Text & Outlined Button
          {
            "hover:bg-warning-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "warning" && !parent.props.plain,
          },
          // Help
          {
            "hover:bg-help-600 dark:hover:bg-help-300 hover:border-help-600 dark:hover:border-help-300":
              parent.props.severity === "help" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-help-400/50 dark:focus:ring-help-300/50": parent.props.severity === "help" },
          // Text & Outlined Button
          { "hover:bg-help-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "help" && !parent.props.plain },
          // Warning
          {
            "hover:bg-danger-600 dark:hover:bg-danger-300 hover:border-danger-600 dark:hover:border-danger-300":
              parent.props.severity === "danger" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-danger-400/50 dark:focus:ring-danger-300/50": parent.props.severity === "danger" },
          // Text & Outlined Button
          { "hover:bg-danger-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "danger" && !parent.props.plain },
          // Transitions
          "transition duration-200 ease-in-out",
          // Misc
          "cursor-pointer overflow-hidden select-none",
        ],
      }),
    },
    menubutton: {
      root: ({ parent }: any) => ({
        class: [
          "relative",
          // Alignments
          "items-center inline-flex text-center align-bottom justify-center",
          // Sizes & Spacing
          "leading-[normal]",
          {
            "px-4 py-3": parent.props.size === null,
            "text-sm py-2 px-3": parent.props.size === "small",
            "text-xl py-3 px-4": parent.props.size === "large",
          },
          {
            "min-w-12 p-0 py-3": parent.props.label == null && parent.props.icon !== null,
          },
          // Shape
          "rounded-l-none",
          { "rounded-l-full": parent.props.rounded },
          { "rounded-md": !parent.props.rounded, "rounded-full": parent.props.rounded },
          // Link Button
          { "text-primary-600 bg-transparent border-transparent": parent.props.link },
          // Plain Button
          { "text-white bg-gray-500 border border-gray-500": parent.props.plain && !parent.props.outlined && !parent.props.text },
          // Plain Text Button
          { "text-surface-500": parent.props.plain && parent.props.text },
          // Plain Outlined Button
          { "text-surface-500 border border-gray-500": parent.props.plain && parent.props.outlined },
          // Text Button
          { "bg-transparent border-transparent": parent.props.text && !parent.props.plain },
          // Outlined Button
          { "bg-transparent border": parent.props.outlined && !parent.props.plain },

          // --- Severity Buttons ---
          // Primary Button
          {
            "text-white dark:text-surface-900":
              !parent.props.link && parent.props.severity === null && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-primary-500 dark:bg-primary-400":
              !parent.props.link && parent.props.severity === null && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-primary-500 dark:border-primary-400":
              !parent.props.link && parent.props.severity === null && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Primary Text Button
          { "text-primary-500 dark:text-primary-400": parent.props.text && parent.props.severity === null && !parent.props.plain },
          // Primary Outlined Button
          {
            "text-primary-500 border border-primary-500 hover:bg-primary-300/20":
              parent.props.outlined && parent.props.severity === null && !parent.props.plain,
          },

          // Secondary Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "secondary" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-secondary-500 dark:bg-secondary-400":
              parent.props.severity === "secondary" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-secondary-500 dark:border-secondary-400":
              parent.props.severity === "secondary" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Secondary Text Button
          { "text-secondary-500 dark:text-secondary-400": parent.props.text && parent.props.severity === "secondary" && !parent.props.plain },
          // Secondary Outlined Button
          {
            "text-secondary-500 border border-secondary-500 hover:bg-secondary-300/20":
              parent.props.outlined && parent.props.severity === "secondary" && !parent.props.plain,
          },

          // Surface Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "surface" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-surface-500 dark:bg-surface-500":
              parent.props.severity === "surface" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-surface-500 dark:border-surface-500":
              parent.props.severity === "surface" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Surface Text Button
          { "text-surface-500 dark:text-surface-400": parent.props.text && parent.props.severity === "surface" && !parent.props.plain },
          // Surface Outlined Button
          {
            "text-surface-500 border border-surface-500 hover:bg-surface-300/20":
              parent.props.outlined && parent.props.severity === "surface" && !parent.props.plain,
          },

          // Success Button
          {
            "text-white! dark:text-surface-900!":
              parent.props.severity === "success" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-success-500 dark:bg-success-400":
              parent.props.severity === "success" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-success-500 dark:border-success-400":
              parent.props.severity === "success" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Success Text Button
          { "text-success-500! dark:text-success-400!": parent.props.text && parent.props.severity === "success" && !parent.props.plain },
          // Success Outlined Button
          {
            "text-success-500 border border-success-500 hover:bg-success-300/20":
              parent.props.outlined && parent.props.severity === "success" && !parent.props.plain,
          },

          // Info Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "info" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-info-500 dark:bg-info-400": parent.props.severity === "info" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-info-500 dark:border-info-400":
              parent.props.severity === "info" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Info Text Button
          { "text-info-500 dark:text-info-400": parent.props.text && parent.props.severity === "info" && !parent.props.plain },
          // Info Outlined Button
          {
            "text-info-500 border border-blue-500 hover:bg-info-300/20 ":
              parent.props.outlined && parent.props.severity === "info" && !parent.props.plain,
          },

          // Warning Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "warning" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-warning-500 dark:bg-warning-400":
              parent.props.severity === "warning" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-warning-500 dark:border-warning-400":
              parent.props.severity === "warning" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Warning Text Button
          { "text-warning-500 dark:text-warning-400": parent.props.text && parent.props.severity === "warning" && !parent.props.plain },
          // Warning Outlined Button
          {
            "text-warning-500 border border-warning-500 hover:bg-warning-300/20":
              parent.props.outlined && parent.props.severity === "warning" && !parent.props.plain,
          },

          // Help Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "help" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-help-500 dark:bg-help-400": parent.props.severity === "help" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-help-500 dark:border-help-400":
              parent.props.severity === "help" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Help Text Button
          { "text-help-500 dark:text-help-400": parent.props.text && parent.props.severity === "help" && !parent.props.plain },
          // Help Outlined Button
          {
            "text-help-500 border border-help-500 hover:bg-help-300/20":
              parent.props.outlined && parent.props.severity === "help" && !parent.props.plain,
          },

          // Danger Button
          {
            "text-white dark:text-surface-900":
              parent.props.severity === "danger" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "bg-danger-500 dark:bg-danger-400":
              parent.props.severity === "danger" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
            "border border-danger-500 dark:border-danger-400":
              parent.props.severity === "danger" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Danger Text Button
          { "text-danger-500 dark:text-danger-400": parent.props.text && parent.props.severity === "danger" && !parent.props.plain },
          // Danger Outlined Button
          {
            "text-danger-500 border border-danger-500 hover:bg-danger-300/20":
              parent.props.outlined && parent.props.severity === "danger" && !parent.props.plain,
          },

          // --- Severity Button States ---
          "focus:outline-hidden focus:outline-offset-0 focus:ring-3",

          // Link
          { "focus:ring-primary-400/50 dark:focus:ring-primary-300/50": parent.props.link },

          // Plain
          { "hover:bg-gray-600 hover:border-gray-600": parent.props.plain && !parent.props.outlined && !parent.props.text },
          // Text & Outlined Button
          { "hover:bg-surface-300/20": parent.props.plain && (parent.props.text || parent.props.outlined) },

          // Primary
          {
            "hover:bg-primary-600 dark:hover:bg-primary-300 hover:border-primary-600 dark:hover:border-primary-300":
              !parent.props.link && parent.props.severity === null && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          {
            "focus:ring-primary-400/50 dark:focus:ring-primary-300/50":
              !parent.props.link && parent.props.severity === null && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          // Text & Outlined Button
          { "hover:bg-primary-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === null && !parent.props.plain },

          // Secondary
          {
            "hover:bg-secondary-600 dark:hover:bg-secondary-300 hover:border-secondary-600 dark:hover:border-secondary-300":
              parent.props.severity === "secondary" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-secondary-400/50 dark:focus:ring-secondary-300/50": parent.props.severity === "secondary" },
          // Text & Outlined Button
          {
            "hover:bg-secondary-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "secondary" && !parent.props.plain,
          },

          // Surface
          {
            "hover:bg-surface-600 dark:hover:bg-surface-400 hover:border-surface-600 dark:hover:border-surface-400":
              parent.props.severity === "surface" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-surface-400/50 dark:focus:ring-surface-300/50": parent.props.severity === "surface" },
          // Text & Outlined Button
          {
            "hover:bg-surface-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "secondary" && !parent.props.plain,
          },

          // Success
          {
            "hover:bg-success-600 dark:hover:bg-success-300 hover:border-success-600 dark:hover:border-success-300":
              parent.props.severity === "success" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-success-400/50 dark:focus:ring-success-300/50": parent.props.severity === "success" },
          // Text & Outlined Button
          {
            "hover:bg-success-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "success" && !parent.props.plain,
          },

          // Info
          {
            "hover:bg-info-600 dark:hover:bg-info-300 hover:border-info-600 dark:hover:border-info-300":
              parent.props.severity === "info" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-info-400/50 dark:focus:ring-info-300/50": parent.props.severity === "info" },
          // Text & Outlined Button
          { "hover:bg-info-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "info" && !parent.props.plain },

          // Warning
          {
            "hover:bg-warning-600 dark:hover:bg-warning-300 hover:border-warning-600 dark:hover:border-warning-300":
              parent.props.severity === "warning" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-warning-400/50 dark:focus:ring-warning-300/50": parent.props.severity === "warning" },
          // Text & Outlined Button
          {
            "hover:bg-warning-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "warning" && !parent.props.plain,
          },

          // Help
          {
            "hover:bg-help-600 dark:hover:bg-help-300 hover:border-help-600 dark:hover:border-help-300":
              parent.props.severity === "help" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-help-400/50 dark:focus:ring-help-300/50": parent.props.severity === "help" },
          // Text & Outlined Button
          { "hover:bg-help-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "help" && !parent.props.plain },

          // Warning
          {
            "hover:bg-danger-600 dark:hover:bg-danger-300 hover:border-danger-600 dark:hover:border-danger-300":
              parent.props.severity === "danger" && !parent.props.text && !parent.props.outlined && !parent.props.plain,
          },
          { "focus:ring-danger-400/50 dark:focus:ring-danger-300/50": parent.props.severity === "danger" },
          // Text & Outlined Button
          { "hover:bg-danger-300/20": (parent.props.text || parent.props.outlined) && parent.props.severity === "danger" && !parent.props.plain },

          // Transitions
          "transition duration-200 ease-in-out",

          // Misc
          "cursor-pointer overflow-hidden select-none",
        ],
      }),
    },
  },
  speedDial: {
    pcAction: {
      root: "bg-surface-500! text-surface-50! border-surface-500! hover:bg-surface-400! hover:border-surface-400! dark:bg-surface-500! dark:text-surface-50! dark:hover:bg-surface-400! dark:border-surface-500! dark:hover:border-surface-400!",
    },
    actionIcon: "text-lg!",
  },
  tabs: {
    tabList: {
      tab: "text-5xl bg-surface-help-500",
    },
  },
};
